const statuses = {
    SUBMITTED: "submitted",
    APPROVED: "approved",
    REJECTED: "rejected"
}
export default statuses;